import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMSApiBase, buildCmsUrl, getResponseCMS } from './base';
import { CMS_URL, isCMSV3 } from 'helpers/conf';

export interface RegistrationBanner extends CMSApiBase {
  title: string;
  offerLine_1: string;
  offerLine_2: string | null;
}

export const registrationBannerV3 = factory((r) => (lang: string) =>
  r<RegistrationBanner>('get', `${CMS_URL}/registration-banner?_locale=${lang}`)
);

export const registrationBannerV4 = factory((r) => (lang: string) =>
  r<RegistrationBanner>(
    'get',
    buildCmsUrl({ path: 'registration-banner', lang }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const registrationBanner = isCMSV3
  ? registrationBannerV3
  : registrationBannerV4;
